import { useFormik } from "formik";
import Input from "../../common/Input";
import * as Yup from "yup";
import { useEffect, useState } from "react";
import { useAuth, useAuthActions } from "../../Providers/AuthProvider";
import TourDefinitionStepper from "../TourDefinitionStepper/TourDefinitionStepper";

const TourDefinitionForm = ({ history }) => {
  const setAuth = useAuthActions();
  const auth = useAuth();

  return <TourDefinitionStepper />;
};

export default TourDefinitionForm;
